import React from 'react';
import PropTypes from 'prop-types';
import {filterNodeProperties} from '../../../../utilities/filter-node-properties';
import {decimaltoHex} from '../../../../utilities/common';

const getDataFromNode = function(node) {
    const keys = ['id', 'title', 'x', 'y', 'width', 'height', 'selectable', 'fontstyle', 'fontcolor'];
    return filterNodeProperties(node, keys, { val: node.val });
};

class QuestionNode extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...getDataFromNode(props.node)
        };
    }

    render() {
        const {x, y, width, height, fontstyle, val, fontcolor} = this.state;
        const divStyle = {
            top: `${y}px`,
            left: `${x}px`,
            fontWeight: fontstyle,
            width: `${width}px`,
            height: `${height}px`,
            wordBreak: 'break-word',
            color: (fontcolor ? `#${decimaltoHex(fontcolor)}` : 'inherit'),
        };

        return (
            <div className="node question-node" style={divStyle} dangerouslySetInnerHTML={{__html:val}} />
        );
    }
}

QuestionNode.propTypes = {
    node: PropTypes.object.isRequired
};

export default QuestionNode;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/question-node.js